import { memo } from 'react';

import { Box, CircularProgress } from '@myn/mui';

import useVersionsTable from './useVersionsTable.jsx';
import VersionsTable from './VersionsTable/index.js';

type Props = {
  sortedVersions?: { id: number }[] | null;
};

const VersionsTableView = ({ sortedVersions }: Props) => {
  const tableProps = useVersionsTable(sortedVersions);

  return tableProps.isVersionsLoading ? (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
      }}
    >
      <CircularProgress size={40} />
    </Box>
  ) : (
    <VersionsTable {...tableProps} />
  );
};

export default memo(VersionsTableView);
